import { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { LOGIN_MEMBER } from '../../../apollo';
import { useAuthedMemberEffect } from './authed-member.effect';
import { setToLocalStorage } from '../../../../utils';
import { LocalStorageKeys } from '../../../../enums/local-storage-keys';

export const useLoginMemberEffect = (
  callback?: (data?: any) => void
): {
  loginMember: (email: string, password: string) => void;
  success: boolean;
  loading: boolean;
  error: string;
} => {
  const authedMemberEffect = useAuthedMemberEffect(callback);

  const [doLoginMember, loginMemberState] = useLazyQuery(LOGIN_MEMBER, {
    onCompleted: (data) => {
      setToLocalStorage(LocalStorageKeys.AUTH_TOKEN, data.loginMember);
      authedMemberEffect.authedMember();
    },
    onError: (error) => {
      setErrorMessage(error.message);
      setLoading(false);
    },
  });

  const [, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const authLoading = authedMemberEffect.loading;
    const authSuccess = authedMemberEffect.success;
    const authError = authedMemberEffect.error;

    if (!authLoading && authSuccess) {
      setSuccess(true);
      setLoading(false);
    }

    if (!authLoading && authError) {
      setErrorMessage(authError);
      setLoading(false);
    }
  }, [loginMemberState, authedMemberEffect, setSuccess, setErrorMessage]);

  const loginMember = (username: string, password: string): void => {
    const variables = { username, password };

    setLoading(true);
    doLoginMember({ variables });
  };

  return {
    loginMember,
    loading,
    success: authedMemberEffect.success,
    error: errorMessage,
  };
};
